import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { FaBars, FaSearch } from "react-icons/fa";
import { useState, useEffect, useRef, useMemo } from "react";
import { AnimatePresence, motion } from "framer-motion";
import SideBarMenu from "./SideBarMenu";
import nestlogo from "../assets/NEST LOGO_Lightv.svg";
import nestHomelogo from "../assets/NestLogo.svg";
import GetIcon from "./IconsComponent";
import routeMap from "./routeMap";
import { Link } from "react-router-dom";
import { updateNavbarHeading } from "../constants/layout/store/filterSlice";
import { useDispatch } from "react-redux";

const SideBar = ({ isOpen, setIsOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const sidebarRef = useRef(null);

  const findRouteKey = (path) => {
    return (
      Object.entries(routeMap)
        .filter(([key, value]) => path.startsWith(value))
        .sort((a, b) => b[1].length - a[1].length)?.[0]?.[0] || null
    );
  };

  const menu = JSON.parse(localStorage.getItem("menu")) || [];


  const rujul_menu = JSON.parse(localStorage.getItem("rujul_menu")) || [];

  // Convert submenus into an object where keys are their titles and values are directly the allmenu array
  const formattedSubmenus = {};
  rujul_menu.forEach((item) => {
    const title = item.menu_details?.title;
    if (title && title != "MASTER" && item.submenus?.allmenu) {
      formattedSubmenus[title] = item.submenus.allmenu;
    }
  });

  const rujulFormatted = {
    menu_details: {
      icon: "fa-solid fa-user-tie",
      title: "ADMIN",
    },
    submenus: formattedSubmenus, // Submenus are now key-value pairs with arrays
  };

  const route_arr =
    formattedSubmenus && Object.keys(formattedSubmenus).length > 0
      ? [...menu, rujulFormatted]
      : [...menu];

  let routeKey = [];
  const { new_routes, alloweObjectIds } = useMemo(() => {
    let new_routes = [];
    let alloweObjectIds = [];
    if (Array.isArray(route_arr)) {
      for (let row of route_arr) {
        if (
          [
            "RMG",
            "PROJECT MANAGEMENT",
            "Human Resource",
            "TIME SHEET",
            "SUPPORT DESK",
            "PAYROLL",
            "ORGANIZATION",
            "Payroll Management",
            "ADMIN",
          ].includes(row.menu_details.title)
        ) {
          let temp = {
            name: row.menu_details.title,
            // path: "/",
            exact: true,
            // icon:  <i classGet(Name={ row.menu_details.icon}/>,
            icon: GetIcon(row.menu_details.icon),
            subRoutes: [],
          };

          let subMenuArr = [];
          if (row.submenus && Object.keys(row.submenus).length > 0) {
            Object.keys(row.submenus).forEach((subkey) => {
              if (
                ![
                  "allmenu",
                  // "Report",
                  // "Training",
                  // "Resource",
                  // "Task",
                  // "Attendance",
                  // "Performance Review",
                  "Imports",
                  "Communication", //rujul
                  "Balance Sheet", //rujul
                  "Trial Balance", //rujul
                  // "Leave Management", //rujul
                  "Profit & Loss", //rujul
                ].includes(subkey)
              ) {
                let subSubRoute = [];
                for (let childMenu of row.submenus[subkey]) {
                  if (
                    ![
                      // "Incentives Master",

                      // "Award Master",

                      "TnE Invoice list (Consulting and Content)",
                      // "TnE Invoice List (Training)",
                      "Update Invoice List (Training)",
                      // "Invoice List (Training)",
                      // "Invoice Report (Training)",
                      "Internal Project",
                      "KPI Report (Training)",
                      // "All Invoice Report",
                      // "All Reports",
                      // "TnE Invoice Report (Consulting and Content)",
                      // "TnE Invoice Report (Training)",
                      // "My Projects",
                      // "Project Status Report",
                      "Cancel Leave Request",
                      "Incentive List (Training)",
                      "Update Invoice List (Consulting & Content)",
                      "Incentive List Fixed Bid",
                      "Team Incentives",
                      "Payroll Statements",
                      "Attendance Approvals",
                      "Attendance Statements",
                      "Accrued Leave Summary",
                      "Available Leave Summary",
                      "Support Ticket Resolution",
                      "Users Permission",
                      "Resource Requisition",
                      "Domains",
                      "Resource Requisition Approval",
                      "Employee Report",
                      "Announcement",
                      "Skills",
                      "Employee",
                      "Employee Qualification",
                      "Attendance Register",
                      "Daily Attendance",
                      // "Income Tax Slab",
                      "Employee Payrolls",
                      "Employee Payrolls List",
                      // "Payroll Statement",
                      "Update Incentive List(Consulting & Content)",
                      "Incentive List",
                      "Employee Leave",
                      "Employee Shifts",
                      "Employee Leave List",
                      "Employee Shifts List",
                      "Payroll Journal Voucher",
                      "Payroll Journal Voucher List",
                      "Employee Payment",
                      "Company Policies",
                      "Widget",
                      "Log Statement",
                      "Active Login User",
                      "Active Login User",
                      "Transaction Log Statement",
                      // "Users Permission",
                      "Dashboard Designer",
                      // "Expense Settlement Statements",
                      "Expense Settlement",
                      "Attendance Register",
                      // "Attendance Statement",
                      // "Attendance Approval",
                      "Scales",
                      // "Attendance Book Statement",
                      "Attendance In Out Summary",
                      "Attendance Log Statement",
                      "Attendance Book Summary",
                    ].includes(childMenu.DiplayName)
                  ) {
                    alloweObjectIds.push(childMenu.ObjectType);
                    subSubRoute.push({
                      path: routeMap[childMenu.ObjectType],
                      name: childMenu.DiplayName,
                      icon: GetIcon(childMenu.Icon?.trim() || childMenu.Icon),
                    });
                  }
                }
                subMenuArr.push({
                  // path: "/",
                  name: subkey,
                  icon: GetIcon(row.submenus[subkey][0].subGroupMenuIcon),
                  subRoutes: subSubRoute,
                });
              }
            });

            temp.subRoutes = subMenuArr;
          }

          if (row.submenus?.allmenu) {
            for (let first_row of row?.submenus?.allmenu) {
              if (
                ![
                  "Attendance Register",
                  // "Attendance Book Statement",
                  "Attendance In Out Summary",
                  "Attendance Log Statement",
                  "Attendance Book Summary",
                  "Holiday",
                  // "Shift",
                  "Forum",
                  "Announcement",
                  "TnE Invoice list (Consulting and Content)",
                  "TnE Invoice List (Training)",
                  "Update Invoice List (Training)",
                  "Invoice List (Training)",
                  "Employee Qualification",
                  "Attendance Status",
                  "HR Calendars",
                  "Company Policies",
                  // "Designation",
                  "Skills",
                  "Employee Report",
                  "Employee List",
                  // "Attendance Statement",
                  // "Attendance Approval",
                  "Daily Attendance",
                  "Mark Attendance",
                  "HR Incentive List",
                  ,
                ].includes(first_row.DiplayName)
              ) {
                alloweObjectIds.push(first_row.ObjectType);
                subMenuArr.push({
                  path: routeMap[first_row.ObjectType],
                  name: first_row.DiplayName,
                  icon: GetIcon(first_row.Icon?.trim() || first_row.Icon),
                });
              }
            }
          }

          temp.subRoutes = subMenuArr;
          new_routes.push(temp);
        }
      }
    }

    return { new_routes, alloweObjectIds };
  }, [route_arr]);

  let path = location.pathname;
  routeKey = findRouteKey(path);


  const actionsArray = [
    "/candidate-details-verify",
    "/view-job-description",
    "/change-password",
    "/RMG/employees",
    "/RMG/sub-contractors",
    "/RMG/employees/view/",
    "/addfeedback",
    "/view-feedbacks",
    "/feedback-link-expire",
    "/feedback-submitted",
    "/offer-accepted",
    "/dashboard",
    "/",
    "/candidate-details",
    "/attendanceCalender",
    "/50881180195049806954114046419509",
    "/leave-approves",
    '/forthcoming',
    '/whatsnew',
    '/achievers',
    '/achievers/leaderboard',
   '/offer-letter-listing'

  ];
  useEffect(() => {
    if (!routeKey) return; // wait for routeKey to be determined

    const isAllowed = alloweObjectIds.includes(Number(routeKey));
    const isCheckedArrayRoute = checkAction(location.pathname);

    console.log("isCheckedArrayRoute", isCheckedArrayRoute);

    if (!isAllowed && !isCheckedArrayRoute) {
      navigate("/", { replace: true });
    }
  }, [routeKey, alloweObjectIds, location.pathname, navigate]);


  function checkAction(path) {
    return actionsArray.some((route) => {
      return path === route || path.startsWith(route + "/") || route.startsWith(path + "/");
    });
  }



  useEffect(() => {
    const handleClickOutside = (event) => {
      // Don't prevent default here - it can interfere with mobile touch events
      if (sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        !event.target.closest('.mobile-menu-icon')) { // Exclude the menu button
        setIsOpen(false);
      }
    };

    // Only add listener when sidebar is open
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside); // For mobile touch
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [isOpen]); // Add isOpen as dependency
  const toggle = (e) => {
    setIsOpen(prev => !prev); // Use functional update to ensure correctness
  };

  const showAnimation = {
    hidden: { width: 0, opacity: 0, },
    show: { opacity: 1, width: "auto", },
  };

  const [activePaths, setActivePaths] = useState([]);


  function handleRouteChange(routes, targetPath, parents = []) {


    for (let route of routes) {
      if (
        route.path === targetPath ||
        targetPath.startsWith(route.path + "/")
      ) {
        // setActiveRoutePageName( route.name)
        return setActivePaths([...parents, route.name]);
      }
      if (route.subRoutes) {
        const result = handleRouteChange(route.subRoutes, targetPath, [
          ...parents,
          route.name,
        ]);
        if (result) return result;
      }
    }
    return null;
  }

  useEffect(() => {
    const result = handleRouteChange(new_routes, location.pathname);
    if (result) {
      setActivePaths(result);
    }
  }, [location.pathname]);
  const handleClicLOgokOutside = (event) => {
    // Only close sidebar if screen width is greater than 576px

    setIsOpen(false);
  };
  const [filteredRoutes, setFilteredRoutes] = useState(new_routes)

  const [isOpenSearch, setIsopenSearch] = useState(false);

  const toggleSearch = (value) => {
    setIsopenSearch(value);
    setActivePaths([]); // reset open state

  };

  const searchRoutes = (routes, value, parents = []) => {
    let matches = [];
    let activePaths = [];

    routes.forEach((route) => {
      const name = route.name || "";
      const currentPath = [...parents, name];
      const pathKey = currentPath.join(">");

      const matchTop = name.toLowerCase().includes(value);

      const childResult = route.subRoutes
        ? searchRoutes(route.subRoutes, value, currentPath)
        : { routes: [], paths: [] };

      if (matchTop || childResult.routes.length > 0) {
        matches.push({
          ...route,
          subRoutes:
            childResult.routes.length > 0 ? childResult.routes : route.subRoutes,
        });

        if (matchTop) {
          activePaths.push(pathKey);
        }
        activePaths.push(...childResult.paths);
      }
    });

    return { routes: matches, paths: activePaths };
  };

  const handleSearchMenu = (e) => {
    const value = e.target.value.toLowerCase();

    if (!value) {
      setFilteredRoutes(new_routes);
      setActivePaths([]); // reset open state
      return;
    }

    const { routes, paths } = searchRoutes(new_routes, value);

    setFilteredRoutes(routes);
    // setActivePaths(paths);
  };

  useEffect(() => {
    if (!isOpen) {
      setIsopenSearch(false);
    }
    setFilteredRoutes(new_routes)
  }, [isOpen])

  return (
    <div className="main-child" ref={sidebarRef}>
      <motion.div
        animate={{
          // height: isOpen ? "503px" : "",
          width: isOpen ? "220px" : "38px",
          // transition: {
          //   duration: 1.2,
          //   type: "spring",
          //   damping: 10,
          // },
        }}
        className={`sidebar ${isOpen ? "" : "close"}`}
      >

        <div className={`top_section ${isOpen ? "" : "open"}`}>
          <AnimatePresence>
            {isOpen && (
              <motion.h1
                // variants={showAnimation}
                initial="hidden"
                // animate="show"
                exit="hidden"
                className="logo"
              >
                <Link to="/">
                  <img src={nestlogo} onClick={handleClicLOgokOutside} className="logoImg" alt="Logo" />
                </Link>
              </motion.h1>
            )}
          </AnimatePresence>
          {isOpen && (<div className="">
            <FaSearch
              onClick={(e) => {
                e.preventDefault();
                toggleSearch(!isOpenSearch);
              }} />
          </div>)}
          <div className="bars">
            <FaBars
              onClick={(e) => {
                e.preventDefault();
                toggle(e);
              }} />
          </div>
        </div>
        {isOpen ? null : <div className="text-center routes"> <img
          src={nestHomelogo}
          className="ps-1"
          style={{
            cursor: "pointer",
            height: "2em",
            width: "2em",
            filter: "brightness(0) invert(1)"
          }}
          onClick={() => navigate("/")}
        />
        </div>}
        {isOpenSearch && <div>
          <input className="form-control" style={{ width: "90%", marginInline: "5%" }} on onChange={(e) => handleSearchMenu(e)} type="text" />
        </div>}
        <div className={`scrollable-section ${isOpen ? "" : "open"}`}>
          <section className="routes">
            {filteredRoutes.map((route, index) => {
              return route.subRoutes ? (
                <SideBarMenu
                  activePaths={activePaths}
                  key={index}
                  setIsOpen={setIsOpen}
                  route={route}
                  showAnimation={showAnimation}
                  isOpen={isOpen}
                />
              ) : (
                <NavLink
                  to={route.path}
                  key={index}
                  className={({ isActive }) => (isActive ? "active" : "link")}
                >
                  <div className="icon">
                    <i className={route.icon}></i>
                  </div>
                  <AnimatePresence>
                    {isOpen && (
                      <motion.div
                        variants={showAnimation}
                        initial="hidden"
                        animate="show"
                        exit="hidden"
                        className="link_text"
                      >
                        {route.name}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </NavLink>
              );
            })}
          </section>
        </div>
      </motion.div>
    </div>
  );
};

export default SideBar;